/* tslint:disable */
/* eslint-disable */
/**
 * Změňte.to Admin API
 * Změňte.to Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveySetStateRequestDTO
 */
export interface SurveySetStateRequestDTO {
    /**
     * 
     * @type {string}
     * @memberof SurveySetStateRequestDTO
     */
    status: SurveySetStateRequestDTOStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum SurveySetStateRequestDTOStatusEnum {
    Solved = 'SOLVED',
    ToBeFinalized = 'TO_BE_FINALIZED'
}

export function SurveySetStateRequestDTOFromJSON(json: any): SurveySetStateRequestDTO {
    return SurveySetStateRequestDTOFromJSONTyped(json, false);
}

export function SurveySetStateRequestDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveySetStateRequestDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
    };
}

export function SurveySetStateRequestDTOToJSON(value?: SurveySetStateRequestDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
    };
}

